import { authService } from "../services/authService";

const state = {
  staffUid: null,
  token: null,
  isImpersonating: false
};

const getters = {
  staffUid: state => state.staffUid,
  token: state => state.token,
  isAuthenticated: state => !!state.token,
  isImpersonating: state => state.isImpersonating
};

const mutations = {
  setStaffUid(state, staffUid) {
    state.staffUid = staffUid;
  },
  saveToken(state, jwt) {
    state.token = jwt;
  },
  setToken: (state, token) => {
    state.token = token;
  },
  setIsImpersonating(state, isImpersonating) {
    state.isImpersonating = isImpersonating;
  }
};

const actions = {
  init: async ({ commit, dispatch }, staffUid) => {
    commit("setStaffUid", staffUid);
    const token = await authService.getToken();
    commit("setIsImpersonating", ['operator', 'admin'].includes(token.actorType));
    commit("setToken", token);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
